import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { SupplyWalkEditableContainer } from "../supply_walk_editable/container";
import { PoModificationsContainer } from "./po_modifications_container";
import { useCustomer } from "../../contexts/app/provider";

export const PoInboxPage = () => {
  const { selectedCustomerId } = useCustomer();
  const [activeTab, setActiveTab] = useState(0);

  if (selectedCustomerId !== "goodchop") {
    return <SupplyWalkEditableContainer />;
  }

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", px: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
        >
          <Tab label="PO Inbox" />
          <Tab label="PO Modifications" />
        </Tabs>
      </Box>
      <Box
        sx={{
          height: "calc(100% - 49px)",
          display: activeTab === 0 ? "block" : "none",
        }}
      >
        <SupplyWalkEditableContainer />
      </Box>
      <Box
        sx={{
          height: "calc(100% - 49px)",
          display: activeTab === 1 ? "block" : "none",
        }}
      >
        <PoModificationsContainer />
      </Box>
    </Box>
  );
};
